import { useTranslation } from 'react-i18next'
import { ConfirmModal } from '@/ui'
import styles from './PackageLoadModals.module.scss'

export const SignAll = ({ handleProcess, handleCancel }) => {
	const { t } = useTranslation()

	return (
		<ConfirmModal
			onProcess={handleProcess}
			onCancel={handleCancel}
			cancelButtonTitle={'no_cancel'}
			processButtonTitle={'yes_sign'}
			hideBackButton
			priority={2}
		>
			<div className={styles.content}>
				<p className={styles.title}>{t('sign_all_title')}</p>
				<p className={styles.text}>{t('sign_all_body')}</p>
			</div>
		</ConfirmModal>
	)
}
